// wp-icons — Users & People (7)
import { createWpIcon } from './createIcon.js';

export const User = createWpIcon('User', [
  ['path', { d: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2', key: 'a' }],
  ['circle', { cx: 12, cy: 7, r: 4, key: 'b' }],
]);
export const Users = createWpIcon('Users', [
  ['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', key: 'a' }],
  ['circle', { cx: 9, cy: 7, r: 4, key: 'b' }],
  ['path', { d: 'M22 21v-2a4 4 0 0 0-3-3.87', key: 'c' }],
  ['path', { d: 'M16 3.13a4 4 0 0 1 0 7.75', key: 'd' }],
]);
export const UserCheck = createWpIcon('UserCheck', [
  ['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', key: 'a' }],
  ['circle', { cx: 9, cy: 7, r: 4, key: 'b' }],
  ['polyline', { points: '16 11 18 13 22 9', key: 'c' }],
]);
export const UserPlus = createWpIcon('UserPlus', [
  ['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', key: 'a' }],
  ['circle', { cx: 9, cy: 7, r: 4, key: 'b' }],
  ['line', { x1: 19, x2: 19, y1: 8, y2: 14, key: 'c' }],
  ['line', { x1: 22, x2: 16, y1: 11, y2: 11, key: 'd' }],
]);
export const UserMinus = createWpIcon('UserMinus', [
  ['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', key: 'a' }],
  ['circle', { cx: 9, cy: 7, r: 4, key: 'b' }],
  ['line', { x1: 22, x2: 16, y1: 11, y2: 11, key: 'c' }],
]);
export const UserX = createWpIcon('UserX', [
  ['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', key: 'a' }],
  ['circle', { cx: 9, cy: 7, r: 4, key: 'b' }],
  ['line', { x1: 17, x2: 22, y1: 8, y2: 13, key: 'c' }],
  ['line', { x1: 22, x2: 17, y1: 8, y2: 13, key: 'd' }],
]);
export const Crown = createWpIcon('Crown', [
  ['path', { d: 'M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z', key: 'a' }],
  ['path', { d: 'M5 21h14', key: 'b' }],
]);
